import { FC, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { CloseIcon, SearchIcon } from '../../assets/icons/index';
import { useDebounce } from '../../hooks/index';
import { AppFormattedMessage } from '../app-formatted-message/index';
import Button from '../button/index';
import { Input } from '../input/index';

export type SearchProps = {
  callback: (searchWDebounce: string) => void;
};

export const Search: FC<SearchProps> = ({ callback }) => {
  const [search, setSearch] = useState('');
  const [isOpenSearch, setOpenSearch] = useState(false);
  const [isFocusedInput, setInputFocus] = useState(false);
  const inputRef = useRef<HTMLDivElement>(null);

  const { debounceCallback } = useDebounce({
    callback,
  });

  const resetSearch = () => {
    handleSearch('');
    setOpenSearch((prev) => !prev);
  };

  const handleSearch = (value: string) => {
    setSearch(value);
    debounceCallback(value);
  };

  return (
    <div className="relative flex h-full w-fit items-center gap-3">
      <div className="flex items-center justify-end" ref={inputRef}>
        <Input
          inputClassName="h-9"
          onBlur={() => setInputFocus(false)}
          onChange={handleSearch}
          onFocus={() => {
            setInputFocus(true);
          }}
          placeholder={!search && <AppFormattedMessage id="SEARCH" />}
          value={search}
          wrapperClassName={twMerge(
            'transition-all duration-500 max-w-[200px] w-full  overflow-hidden h-9',
            isOpenSearch ? 'delay-500' : 'w-0',
          )}
        />
        {isOpenSearch && search && (
          <div
            className="absolute mr-8 cursor-pointer p-2"
            onClick={() => {
              handleSearch('');
            }}
          >
            <CloseIcon />
          </div>
        )}
        <Button
          className={twMerge(
            'flex size-9 shrink-0 items-center justify-center rounded border-[1px] border-gray-100 bg-gray-25 transition-all duration-500',
            isOpenSearch
              ? 'h-9 rounded-l-none rounded-br-none border-x-0 border-t-0 border-b-black'
              : 'delay-1000',
            isFocusedInput && 'border-b-[2px] border-b-brand-700 transition-none',
          )}
          onClick={resetSearch}
          styleType="NONE"
        >
          <div className="transition-colors duration-500">
            <SearchIcon iconColor={isFocusedInput ? '#2565C8' : '#344054'} />
          </div>
        </Button>
      </div>
    </div>
  );
};
